import React from 'react'

const MapIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="mapGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(120, 200, 160, 1)" />
          <stop offset="100%" stopColor="rgba(80, 160, 120, 1)" />
        </linearGradient>
        <filter id="mapGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Map outline */}
      <path 
        d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6z"
        stroke="url(#mapGradient)"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
        filter="url(#mapGlow)"
      />
      
      {/* Fold lines */}
      <line 
        x1="9" 
        y1="3" 
        x2="9" 
        y2="18" 
        stroke="url(#mapGradient)"
        strokeWidth="1.5"
        strokeDasharray="2,2"
      />
      <line 
        x1="15" 
        y1="6" 
        x2="15" 
        y2="21" 
        stroke="url(#mapGradient)"
        strokeWidth="1.5"
        strokeDasharray="2,2"
      />
    </svg>
  )
}

export default MapIcon
